import { URI } from '@/config/config';

export default async ({ rootState }, { payload, clientId }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  const result = await fetch(`${URI}client/${clientId}`, opts);
  const jsonResult = await result.json();

  if (result.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
